var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShortGreenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-6.99382e-07 16C-3.13161e-07 24.8357 7.16429 32 16 32C24.8357 32 32 24.8357 32 16C32 7.16428 24.8357 -2.51612e-06 16 -2.12989e-06C7.16428 -1.74367e-06 -1.0856e-06 7.16428 -6.99382e-07 16ZM12.6321 9.41071L21.4179 15.7679C21.4544 15.7942 21.4841 15.8288 21.5046 15.8688C21.5251 15.9089 21.5358 15.9532 21.5358 15.9982C21.5358 16.0432 21.5251 16.0876 21.5046 16.1276C21.4841 16.1677 21.4544 16.2023 21.4179 16.2286L12.6321 22.5857C12.4429 22.7214 12.1786 22.5857 12.1786 22.3536L12.1786 20.6786C12.1786 20.3143 12.3536 19.9679 12.65 19.7536L17.8429 16L12.65 12.2429C12.3536 12.0286 12.1786 11.6857 12.1786 11.3179L12.1786 9.64286C12.1786 9.41071 12.4429 9.275 12.6321 9.41071V9.41071Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortGreenArrow);
export default __webpack_public_path__ + "static/media/shortGreenArrow.5f6c8e6874cb0aed1ac9c85694e23173.svg";
export { ForwardRef as ReactComponent };